import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {assert} from 'Asserts';
import {Sequence} from 'components/Sequence';
import {BulkSetModsParams} from 'constants/SequenceOpConstants';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import {NucleotideComponent} from './MonomerConstants';
import NucleotidesTab from './NucleotidesTab';
import NucleotidesTabState from './NucleotidesTabState';

class NucleotidesTabView extends Backbone.View<NucleotidesTabState> {
  override initialize(): void {
    this.listenTo(
      this.model.sequence().get('_sequence'),
      'change:bases change:modifiedNucleotides',
      this.render.bind(this)
    );
  }

  override render(): Backbone.View<NucleotidesTabState> {
    if (!(this.model.sequence() instanceof Sequence)) {
      throw new Error('Can only open nucleotides tab for sequence');
    }
    const sequence = this.model.sequence();

    renderToDOM(
      <NucleotidesTab
        areEditsEnabled={sequence.allowResidueEdits()}
        bases={sequence.bases()}
        nucleotideType={sequence.nucleotideType()}
        sequenceId={this.model.sequence().id}
        onUpdateMod={async (position, monomerId, monomerType) => {
          assert(
            monomerType === NucleotideComponent.PHOSPHATE || monomerId != null,
            'Can only specify null monomer for phosphate'
          );
          switch (monomerType) {
            case NucleotideComponent.SUGAR: {
              sequence.setSugarMod(position, monomerId!);
              break;
            }
            case NucleotideComponent.PHOSPHATE: {
              sequence.setPhosphateMod(position, monomerId);
              break;
            }
            case NucleotideComponent.BASE: {
              await sequence.setBaseMod(position, monomerId!);
              break;
            }
            default: {
              assert(false, 'Unexpected nucleotide component');
            }
          }
        }}
        onBulkUpdateMods={(params: BulkSetModsParams) => {
          sequence.bulkSetMods(params);
        }}
      />,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<NucleotidesTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

NucleotidesTabView.prototype.className = 'buffer-tab';

export default NucleotidesTabView;
